export const palette = {
  //TODO
};
